"use client";

import dynamic from "next/dynamic";

import { LayerLoading } from "@/components/host-panel/shell/layer-loading";

/**
 * The quantity and pack dialog, outside the initial bundle (criterion 23.6).
 *
 * `loading` exists because the cost of leaving the initial bundle is a wait: without it the tap
 * produces nothing until the chunk lands. The module is `.tsx` only for that, since `dynamic`
 * needs an element.
 */
export const PackDialogLazy = dynamic(
  () => import("./pack-dialog").then((module) => module.PackDialog),
  {
    ssr: false,
    loading: () => <LayerLoading label="Abrindo as opções da peça" />,
  },
);
